module.exports = __webpack_public_path__ + "fonts/Catamaran-Black.6f7344e5.woff";